import React from 'react';
import { Outlet } from 'react-router-dom';
import DashboardNavbar from '../components/layout/DashboardNavbar';

const CoachLayout = () => {
  return (
    <div className="min-h-screen bg-jp-section ">
      {/* Navbar */}
      <DashboardNavbar userRole="coach" />

      {/* Page Content */}
      <div className="pt-16 sm:pt-20">
        <Outlet />
      </div>
    </div>
  );
};

export { CoachLayout };
export default CoachLayout;
